import moment from "moment";

const startDateFilter = (filter, dealStartDate) => {
  if (!filter || (!filter.from && !filter.to)) return true;
  if (!dealStartDate) return false;

  const startDate = moment(dealStartDate).startOf("day");

  return (
    startDate.isBetween(filter.from, filter.to, null, "[]") ||
    (!filter.to && startDate.isSameOrAfter(filter.from)) ||
    (!filter.from && startDate.isSameOrBefore(filter.to))
  );
};

export default startDateFilter;
